module.exports = __webpack_public_path__ + "static/media/cq_richieste_finanziamenti b.b2824caf.svg";